import CalendarioImpl from 'components/calendario/CalendarioImpl'
import React from 'react'
import { Col, Row } from 'reactstrap'

const ViewCalendarios = () => {
  return (
    <Row>
        <Col>
         <CalendarioImpl></CalendarioImpl>
        </Col>
      </Row>
  )
}

export default ViewCalendarios